<template>
    <div style="padding-top: 41px;" v-loading.fullscreen.lock="isLoading" element-loading-text="数据正在加载中" >
        <div id="topFix">
            <topNav></topNav>
        </div>
        <miniNav></miniNav>
        <Header></Header>
        <SubNav></SubNav>
        <div class="pageWidth">
            <div class="location mt20">
                <a href="//auction.artron.net /" class="">拍卖</a><a class="lastLink" href="/brand">品牌专区</a><strong>列表</strong>
            </div>
            <div class="bg ser fix">
                <h2 class="fix"><a class="serW fl">查找机构</a><a href="#" class="reChoice fr">重新选择</a></h2>
                <FilterSearch :areaList="areaList" :cityList="cityList" :classList="classList" :letterList="letterList"></FilterSearch>
            </div>
            <div class="main fix mt30">
                <OrganList></OrganList>
            </div>
        </div>
        <Contact></Contact>
        <Footer></Footer>
    </div>
</template>

<script>
import topNav from "@/components/oldCommon/topNav";
import miniNav from "@/components/oldCommon/miniNav";
import Header from "@/components/oldCommon/header";
import SubNav from "@/components/oldCommon/subNav";
import Contact from "@/views/brand/components/contact";
import Footer from "@/components/oldCommon/footer";
import FilterSearch from "@/views/brand/components/filter";
import OrganList from "@/views/brand/components/OrganList";
import {getClass} from "@/api/brand";
import {
    mapActions,mapGetters
} from 'vuex';
export default {
    name: "mechanismsearch",
    components:{
        topNav,miniNav,Header,SubNav,Contact,Footer,FilterSearch,OrganList
    },
    data(){
        return{
            areaList:[],
            cityList:[],
            classList:[],
            letterList:[],
            isLoading:true
        }
    },

    asyncData({ store }) {
        let params = {
            type:6,
        }
        return store.dispatch("pageBrandList/getBrandList", [params, () => {}]);
    },
    computed:{
        ...mapGetters({
            getIsLoadIng: "pageBrandList/getIsLoadIng",
            getData: "pageBrandList/getData",
        }),
    },
    mounted() {
        this.getClass();
        if (!this.getIsLoadIng){
            let parmas = {
                type:6
            }
            this.getBrandList([parmas,()=>{
                this.filteData();
            }])
        }else{
            this.filteData();
        }
    },
    methods:{
        ...mapActions({
            getBrandList:"pageBrandList/getBrandList"
        }),
        filteData(){
            let data = this.$store.state["pageBrandList"]["data"]
            console.log(data)
            let meta = data.meta;
            let head = document.getElementsByTagName('head');
            document.title = meta.title
            if(!document.querySelector('meta[name=description]')){
                let meta2 = document.createElement('meta');
                meta2.name = 'description';
                meta2.content = meta.description || '';
                head[0].appendChild(meta2)
            }else{
                document.querySelector('meta[name=description]').setAttribute('content',meta.description || '')
            }
        },
        getClass(){
            getClass().then((res) => {
                if(res.code == 0){
                    let dataJSON = res.data
                    this.areaList = dataJSON.area_list
                    this.cityList = dataJSON.city_list
                    this.classList = dataJSON.class_list
                    this.letterList = dataJSON.letter_list
                    this.isLoading = false
                }
            })
        }
    }
}
</script>

<style scoped>
@import url('../../assets/css/resetOld.scss');
.ser h2 {
    padding: 9px 10px;
    line-height: 14px;
}
.ser h2 .serW {
    display: block;
}
.ser h2 .reChoice {
    display: none;
    font-family: simSun;
    font-size: 12px;
    font-weight: normal;
    background: #0F820C;
    color: #fff;
    width: 77px;
    height: 20px;
    line-height: 20px;
    text-align: center;
}
.ser .filterWrap {
    background-color: #FFF;
    margin: 0 10px 10px;
    padding: 10px;
}
</style>